import React, {useEffect} from 'react';
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
// import {Actions as MYACTIONS} from './store/actions/myActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';
// import RegistrationForm from '../components/common/RegistrationForm'


import jonathanMifsudPhoto from '../../assets/images/team/jonathan-mifsud.jpg';
import jeremyMifsudPhoto from '../../assets/images/team/jeremy-mifsud.jpg';
import davidSeisunPhoto from '../../assets/images/team/david-seisun.jpg';



function Security({

}) {


  return (

    <div className="">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:py-16 sm:px-6 lg:px-8 lg:py-20">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl font-extrabold text-white sm:text-4xl">
            Security is at the core of our product
          </h2>
          <p className="mt-3 text-xl text-indigo-200 sm:mt-4">
            Information Security ISO/IEC 27001:2013 Certified
          </p>
        </div>
        <dl className="mt-10 text-center sm:max-w-3xl sm:mx-auto sm:grid sm:grid-cols-3 sm:gap-8">
          <div className="flex flex-col">
            <dt className="order-2 mt-2 text-lg leading-6 font-medium text-indigo-200">
              Encryption
            </dt>
            <dd className="order-1 text-5xl font-extrabold text-white">
              AES 256
            </dd>
          </div>
          <div className="flex flex-col mt-10 sm:mt-0">
            <dt className="order-2 mt-2 text-lg leading-6 font-medium text-indigo-200">
              Datacenter
            </dt>
            <dd className="order-1 text-5xl font-extrabold text-white">
              EU
            </dd>
          </div>
          <div className="flex flex-col mt-10 sm:mt-0">
            <dt className="order-2 mt-2 text-lg leading-6 font-medium text-indigo-200">
              ISO 27001:2013
            </dt>
            <dd className="order-1 text-5xl font-extrabold text-white">
              CERTIFIED
            </dd>
          </div>
        </dl>
      </div>
    </div>


    
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my


  return {
    // showSidebar: state.sidebar.show,
    // loggedIn: state.my.profile ? true : false,
  }
}

const mapDispatchToProps = dispatch => ({
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Security) 
